import type { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';
import { PennyProvider, getDefaultIconsMap, getDefaultIllustrations } from '@melio/penny';

// App-wide @melio/penny setup. Penny primitives (Button, Card, Pill, …) used across the
// portal require this provider at the root. Icons/illustrations are served from penny's CDN.
const PENNY_CDN_URL = 'https://penny-static-dev.melioservices.com';
const PENNY_CONFIG = { cdnUrl: PENNY_CDN_URL };
const PENNY_THEME = {
  icons: getDefaultIconsMap(PENNY_CDN_URL),
  illustrations: getDefaultIllustrations(PENNY_CDN_URL),
};

export function PennyRoot({ children }: { children: ReactNode }) {
  return (
    <IntlProvider locale="en">
      <PennyProvider config={PENNY_CONFIG} theme={PENNY_THEME}>
        {children}
      </PennyProvider>
    </IntlProvider>
  );
}
